var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.22222C1 1.89807 1.12261 1.58719 1.34085 1.35798C1.5591 1.12877 1.8551 1 2.16375 1H5.655V6.5V12H2.16375C1.8551 12 1.5591 11.8712 1.34085 11.642C1.12261 11.4128 1 11.1019 1 10.7778V2.22222ZM7.9825 1H11.4737C11.7824 1 12.0784 1.12877 12.2966 1.35798C12.5149 1.58719 12.6375 1.89807 12.6375 2.22222V5.27778H7.9825V1ZM7.9825 7.72222H12.6375V10.7778C12.6375 11.1019 12.5149 11.4128 12.2966 11.642C12.0784 11.8712 11.7824 12 11.4737 12H7.9825V7.72222Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.808bce799f3065a6e8ec34c3c4a12887.svg";
export { ForwardRef as ReactComponent };